import { Route } from "react-router-dom/cjs/react-router-dom.min"
import DriverSalary from "./DriverSalary/DriverSalary"
import DriverTripPayment from "./DriverTripPayment/DriverTripPayment"
import DriverAdvancePayV2 from "./DriverAdvancePay/DriverAdvancePayV2"
import NoWorkTruck from "./NoWorkTruck/NoWorkTruck"


export const branchApiNm = {
  getJobOrderAllDetail: "/branch/getJobOrderAllDetail"
}
export const extraPageName = {
  DriverTripPayment: "ค่าเที่ยว พนักงานขับรถ",
  DriverSalary: "เงินเดือนพนักงานขับรถ",
  DriverAdvancePay: "เงินเบิกล่วงหน้า",
  NoWorkTruck: "รายงานรถไม่วิ่งงงาน",
}
export const extraPageMenu = [
  { page: "DriverTripPayment", num: "8.1", menuName: extraPageName.DriverTripPayment, prNum: 8 },
  { page: "DriverAdvancePay", num: "8.2", menuName: extraPageName.DriverAdvancePay, prNum: 8 },
  { page: "DriverSalary", num: "8.3", menuName: extraPageName.DriverSalary, prNum: 8 },
  { page: "NoWorkTruck", num: "8.4", menuName: extraPageName.NoWorkTruck, prNum: 8 },
]

export const extraRoute = (path) => [
  <Route key={"DriverTripPayment"} path={`${path}/DriverTripPayment`} ><DriverTripPayment /> </Route>,
  <Route key={"DriverAdvancePay"} path={`${path}/DriverAdvancePay`} ><DriverAdvancePayV2 /> </Route>,
  <Route key={"DriverSalary"} path={`${path}/DriverSalary`} ><DriverSalary /> </Route>,
  <Route key={"NoWorkTruck"} path={`${path}/NoWorkTruck`} ><NoWorkTruck /> </Route>,
]

export const extraMainRoute = (path) => []
